import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import UpdateNotification from './components/UpdateNotification';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <UpdateNotification />
  </React.StrictMode>
);

// Service Worker Registrierung für PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', {
      updateViaCache: 'none'
    })
      .then((registration) => {
        console.log('✅ Service Worker registriert:', registration.scope);
      })
      .catch((error) => {
        console.error('❌ Service Worker Registrierung fehlgeschlagen:', error);
      });
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
